import { Component } from '@angular/core';

@Component({
  selector : 'app-footer',
  template : `
    <footer>
      <div class="row column text-center">
        <p><b>Trösten Transport</b> - Todos los derechos reservados | <a href="mailto:soporte@gyo-solutions.com">soporte@gyo-solutions.com</a></p>
      </div>
    </footer>
  `
})

export class FooterComponent {

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/footer.component.ts